// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--90711";
export var cdsAssistiveText = "Accordion-module--cds--assistive-text--6d91d";
export var cdsHideFeedback = "Accordion-module--cds--hide-feedback--37794";
export var cdsShowFeedback = "Accordion-module--cds--show-feedback--a8570";
export var cdsSkeleton = "Accordion-module--cds--skeleton--a0824";
export var cdsVisuallyHidden = "Accordion-module--cds--visually-hidden--116fe";